import { useSyncExternalStore } from "react"

/**
 * Global state tracking which editor is active.
 *
 * The active editor is the last one focused, if any. That editor will stay active,
 * even when blurred, until another *editor* is focused. This prevents becoming
 * inactive when you interact with an editor's own comments/modals/etc.
 *
 * When an editor is active:
 * - Its comments are expanded.
 */

let activeEditorId: string | null = null
const listeners = new Set<() => void>()

export function setActiveEditorId(editorId: string | null): void {
  if (editorId === activeEditorId) return
  activeEditorId = editorId
  for (const listener of listeners) {
    listener()
  }
}

export function getActiveEditorId(): string | null {
  return activeEditorId
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function useActiveEditorId(): string | null {
  return useSyncExternalStore(subscribe, getActiveEditorId)
}
